import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { PACKAGES, CATEGORY_RANGES } from "../data/content";

const groups = ["Interior", "Exterior", "In & Out"];

export default function Pricing() {
  return (
    <Layout>
      <section className="max-w-6xl mx-auto px-6 py-16 md:py-24">
        <p className="text-xs tracking-[0.3em] uppercase text-pink-500 font-bold mb-4">Transparent Pricing</p>
        <h1 className="text-4xl md:text-6xl font-extrabold tracking-tighter">Packages & pricing</h1>
        <p className="text-zinc-400 mt-4 max-w-2xl text-lg">Every package is priced for two vehicle sizes: Standard Sedan and 3-row SUV / Truck. Select one package per car when you book.</p>

        {groups.map((g) => (
          <div key={g} className="mt-14">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
              <div className="flex items-baseline gap-3">
                <h2 className="text-2xl md:text-3xl font-bold tracking-tight">{g}</h2>
                <span className="text-pink-500 font-bold">{CATEGORY_RANGES[g]}</span>
              </div>
              <Link to={`/services/${g === "Interior" ? "interior" : g === "Exterior" ? "exterior" : "full"}`} className="text-sm text-pink-500 font-semibold hover:underline" data-testid={`pricing-procedure-${g}`}>View full procedure →</Link>
            </div>
            <div className="grid gap-5 md:grid-cols-2">
              {PACKAGES.filter((p) => p.group === g).map((p) => (
                <div key={p.key} className="rounded-2xl border border-white/10 hover:border-pink-500/50 bg-[#121212] p-7 transition-colors" data-testid={`pkg-${p.key}`}>
                  <h3 className="text-xl font-bold">{p.name}</h3>
                  <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{p.desc}</p>
                  <div className="mt-6 flex gap-8">
                    <div><p className="text-xs uppercase tracking-widest text-zinc-500 mb-1">Sedan</p><p className="text-3xl font-extrabold">${p.sedan}</p></div>
                    <div><p className="text-xs uppercase tracking-widest text-zinc-500 mb-1">SUV / Truck</p><p className="text-3xl font-extrabold text-pink-500">${p.suv}</p></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="mt-16 rounded-2xl border border-white/10 bg-[#121212] p-8 flex flex-wrap items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-bold">Ready to book?</h3>
            <p className="text-zinc-400 mt-1">Pay a 30% deposit or 100% now and save 5% on your next detail.</p>
          </div>
          <Link to="/book" target="_blank" rel="noopener noreferrer" className="bg-pink-600 hover:bg-pink-500 text-white font-semibold rounded-full px-8 py-4 transition-colors active:scale-95" data-testid="pricing-book-btn">Book Now</Link>
        </div>
      </section>
    </Layout>
  );
}
